import { render, staticRenderFns } from "./CompanyItemCategorySetting.vue?vue&type=template&id=48c0ae18&scoped=true"
import script from "./CompanyItemCategorySetting.vue?vue&type=script&lang=js"
export * from "./CompanyItemCategorySetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyItemCategorySetting.vue?vue&type=style&index=0&id=48c0ae18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c0ae18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c0ae18')) {
      api.createRecord('48c0ae18', component.options)
    } else {
      api.reload('48c0ae18', component.options)
    }
    module.hot.accept("./CompanyItemCategorySetting.vue?vue&type=template&id=48c0ae18&scoped=true", function () {
      api.rerender('48c0ae18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanyItemCategorySetting.vue"
export default component.exports